import { Form, Spin, Typography } from "antd/es";
import { connect } from "react-redux";
import {
  Button,
  KCol,
  KPanel,
  KRow,
  Label,
  VerticalStack,
} from "../../components/web-components";
import {
  hideImportMappedExcelModal,
  hideIyzicoDrawer,
  hidePhotoTake,
  hideStripeDrawer,
  showImportMappedExcelModal,
  showIyzicoDrawer,
  showPhotoTake,
  showStripeDrawer,
} from "../../redux/modals/actions";
import { AppState } from "../../redux/root-reducer";
import { withContext } from "../../shared/hoc/with-context";
import { withForm } from "../../shared/hoc/with-form";
import { withGoogleLogin } from "../../shared/hoc/with-google-login";
import { withHistory } from "../../shared/hoc/with-history";
import { withScreenInput } from "../../shared/hoc/with-screen-input";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { SideMenu_ScreenBase } from "./sidemenu-base";

declare let window: any;
const { Title, Paragraph, Text, Link } = Typography;
const menuMap = [];

class SideMenu_Screen extends SideMenu_ScreenBase {
  render() {
    if (this.state.isPageVisible === false) {
      return <></>;
    }
    return (
      <>
        <Spin spinning={this.state.spinnerCount > 0}>
          <Form
            form={this.props.form}
            name="basic"
            initialValues={{}}
            onValuesChange={(changedValues, allValues) => {
              this.clearFieldValidation(changedValues);
            }}
          >
            <>
              <div
                key="-1"
                id="sidemenu_body"
                style={
                  {
                    borderStyle: "solid",
                    borderTopWidth: 0,
                    borderRightWidth: 0,
                    borderBottomWidth: 0,
                    borderLeftWidth: 0,
                    backgroundColor: "#FFFFFF",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "left",
                    paddingTop: 0,
                    paddingRight: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    display: "block",
                  } as any
                }
              >
                <KPanel
                  key="24223"
                  id="24223"
                  scrolling="hidden"
                  scrollRadius={false}
                  style={
                    {
                      borderTopLeftRadius: 0,
                      borderTopRightRadius: 0,
                      borderBottomRightRadius: 0,
                      borderBottomLeftRadius: 0,
                      backgroundColor: "#FFFFFF",
                      paddingTop: 0,
                      paddingRight: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                    } as any
                  }
                >
                  <VerticalStack
                    key="839451"
                    id="839451"
                    direction="vertical"
                    size={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KPanel
                      key="463206"
                      id="463206"
                      scrolling="hidden"
                      scrollRadius={false}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          backgroundColor: "#FFFFFF",
                          paddingTop: 24,
                          paddingRight: 24,
                          paddingBottom: 16,
                          paddingLeft: 24,
                        } as any
                      }
                    >
                      <KRow
                        key="34382"
                        id="34382"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                          } as any
                        }
                      >
                        <KCol
                          key="576431"
                          id="576431"
                          xs={18}
                          sm={18}
                          md={18}
                          lg={18}
                          xl={18}
                          xxl={18}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              alignItems: "center",
                            } as any
                          }
                        >
                          <Label
                            key="217426"
                            id="217426"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              217426,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                display: "block",
                                fontWeight: 700,
                                fontSize: "22px",
                                color: "#111111",
                              } as any
                            }
                          ></Label>
                        </KCol>
                        <KCol
                          key="385012"
                          id="385012"
                          xs={6}
                          sm={6}
                          md={6}
                          lg={6}
                          xl={6}
                          xxl={6}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              alignItems: "center",
                              textAlign: "-webkit-right",
                            } as any
                          }
                        >
                          <Button
                            key="454803"
                            id="454803"
                            label={ReactSystemFunctions.translate(
                              this.ml,
                              454803,
                              "label",
                              this.defaultML
                            )}
                            size="middle"
                            loading={false}
                            ghost={false}
                            block={false}
                            htmlType="button"
                            iconPosition="left"
                            danger={false}
                            style={
                              {
                                borderTopLeftRadius: 8,
                                borderTopRightRadius: 8,
                                borderBottomRightRadius: 8,
                                borderBottomLeftRadius: 8,
                                borderTopWidth: 1,
                                borderRightWidth: 1,
                                borderBottomWidth: 1,
                                borderLeftWidth: 1,
                                borderColor: "transparent",
                                borderStyle: "solid",
                                backgroundColor: "transparent",
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                fontWeight: 400,
                                fontSize: "18px",
                                color: "#888888",
                              } as any
                            }
                          ></Button>
                        </KCol>
                      </KRow>
                    </KPanel>
                    <KPanel
                      key="403905"
                      id="403905"
                      scrolling="vertical"
                      scrollRadius={false}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          backgroundColor: "#FFFFFF",
                          paddingTop: 14,
                          paddingBottom: 14,
                        } as any
                      }
                    >
                      <VerticalStack
                        key="824729"
                        id="824729"
                        direction="vertical"
                        size={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <Button
                          key="562533"
                          id="562533"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.SideMenuComponent_562533_onClick();
                          }}
                          showCursorPointer
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            562533,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="home"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "#FFFFFF",
                              paddingTop: 16,
                              paddingRight: 24,
                              paddingBottom: 16,
                              paddingLeft: 24,
                              minHeight: "56px",
                              textAlign: "-webkit-left",
                              fontWeight: 500,
                              fontSize: "17px",
                              color: "#111111",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="501546"
                          id="501546"
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            501546,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="notifications_active"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "#FFFFFF",
                              paddingTop: 16,
                              paddingRight: 24,
                              paddingBottom: 16,
                              paddingLeft: 24,
                              minHeight: "56px",
                              textAlign: "-webkit-left",
                              fontWeight: 500,
                              fontSize: "17px",
                              color: "#111111",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="595111"
                          id="595111"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.SideMenuComponent_595111_onClick();
                          }}
                          showCursorPointer
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            595111,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="assignment"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "#FFFFFF",
                              paddingTop: 16,
                              paddingRight: 24,
                              paddingBottom: 16,
                              paddingLeft: 24,
                              minHeight: "56px",
                              textAlign: "-webkit-left",
                              fontWeight: 500,
                              fontSize: "17px",
                              color: "#111111",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="667092"
                          id="667092"
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            667092,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="home"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "#FFFFFF",
                              paddingTop: 16,
                              paddingRight: 24,
                              paddingBottom: 16,
                              paddingLeft: 24,
                              minHeight: "56px",
                              textAlign: "-webkit-left",
                              fontWeight: 500,
                              fontSize: "17px",
                              color: "#111111",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="259603"
                          id="259603"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.SideMenuComponent_259603_onClick();
                          }}
                          showCursorPointer
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            259603,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="collections"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "#FFFFFF",
                              paddingTop: 16,
                              paddingRight: 24,
                              paddingBottom: 16,
                              paddingLeft: 24,
                              minHeight: "56px",
                              textAlign: "-webkit-left",
                              fontWeight: 500,
                              fontSize: "17px",
                              color: "#111111",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="389085"
                          id="389085"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.SideMenuComponent_389085_onClick();
                          }}
                          showCursorPointer
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            389085,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="view_module"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "#FFFFFF",
                              paddingTop: 16,
                              paddingRight: 24,
                              paddingBottom: 16,
                              paddingLeft: 24,
                              minHeight: "56px",
                              textAlign: "-webkit-left",
                              fontWeight: 500,
                              fontSize: "17px",
                              color: "#111111",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="657286"
                          id="657286"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.SideMenuComponent_657286_onClick();
                          }}
                          showCursorPointer
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            657286,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="list_alt"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "#FFFFFF",
                              paddingTop: 16,
                              paddingRight: 24,
                              paddingBottom: 16,
                              paddingLeft: 24,
                              minHeight: "56px",
                              textAlign: "-webkit-left",
                              fontWeight: 500,
                              fontSize: "17px",
                              color: "#111111",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="177343"
                          id="177343"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.SideMenuComponent_177343_onClick();
                          }}
                          showCursorPointer
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            177343,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="inventory"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "#FFFFFF",
                              paddingTop: 16,
                              paddingRight: 24,
                              paddingBottom: 16,
                              paddingLeft: 24,
                              minHeight: "56px",
                              textAlign: "-webkit-left",
                              fontWeight: 500,
                              fontSize: "17px",
                              color: "#111111",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="676233"
                          id="676233"
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            676233,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="assignment"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "#FFFFFF",
                              paddingTop: 16,
                              paddingRight: 24,
                              paddingBottom: 16,
                              paddingLeft: 24,
                              minHeight: "56px",
                              textAlign: "-webkit-left",
                              fontWeight: 500,
                              fontSize: "17px",
                              color: "#111111",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="877251"
                          id="877251"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.SideMenuComponent_877251_onClick();
                          }}
                          showCursorPointer
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            877251,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="shopping_cart"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "#FFFFFF",
                              paddingTop: 16,
                              paddingRight: 24,
                              paddingBottom: 16,
                              paddingLeft: 24,
                              minHeight: "56px",
                              textAlign: "-webkit-left",
                              fontWeight: 500,
                              fontSize: "17px",
                              color: "#111111",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="341952"
                          id="341952"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.SideMenuComponent_341952_onClick();
                          }}
                          showCursorPointer
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            341952,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="favorite"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "#FFFFFF",
                              paddingTop: 16,
                              paddingRight: 24,
                              paddingBottom: 16,
                              paddingLeft: 24,
                              minHeight: "56px",
                              textAlign: "-webkit-left",
                              fontWeight: 500,
                              fontSize: "17px",
                              color: "#111111",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="497472"
                          id="497472"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.SideMenuComponent_497472_onClick();
                          }}
                          showCursorPointer
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            497472,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="notifications"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "#FFFFFF",
                              paddingTop: 16,
                              paddingRight: 24,
                              paddingBottom: 16,
                              paddingLeft: 24,
                              minHeight: "56px",
                              textAlign: "-webkit-left",
                              fontWeight: 500,
                              fontSize: "17px",
                              color: "#111111",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="439547"
                          id="439547"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.SideMenuComponent_439547_onClick();
                          }}
                          showCursorPointer
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            439547,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="share"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "#FFFFFF",
                              paddingTop: 16,
                              paddingRight: 24,
                              paddingBottom: 16,
                              paddingLeft: 24,
                              minHeight: "56px",
                              textAlign: "-webkit-left",
                              fontWeight: 500,
                              fontSize: "17px",
                              color: "#111111",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="596575"
                          id="596575"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.SideMenuComponent_596575_onClick();
                          }}
                          showCursorPointer
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            596575,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="person"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "#FFFFFF",
                              paddingTop: 16,
                              paddingRight: 24,
                              paddingBottom: 16,
                              paddingLeft: 24,
                              minHeight: "56px",
                              textAlign: "-webkit-left",
                              fontWeight: 500,
                              fontSize: "17px",
                              color: "#111111",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="788556"
                          id="788556"
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            788556,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="translate"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "#FFFFFF",
                              paddingTop: 16,
                              paddingRight: 24,
                              paddingBottom: 16,
                              paddingLeft: 24,
                              minHeight: "56px",
                              textAlign: "-webkit-left",
                              fontWeight: 500,
                              fontSize: "17px",
                              color: "#111111",
                            } as any
                          }
                        ></Button>
                        <Button
                          key="907656"
                          id="907656"
                          label={ReactSystemFunctions.translate(
                            this.ml,
                            907656,
                            "label",
                            this.defaultML
                          )}
                          size="middle"
                          loading={false}
                          ghost={false}
                          block={false}
                          htmlType="button"
                          icon="help_outline"
                          iconPosition="left"
                          danger={false}
                          style={
                            {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                              borderBottomRightRadius: 8,
                              borderBottomLeftRadius: 8,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "#FFFFFF",
                              paddingTop: 16,
                              paddingRight: 24,
                              paddingBottom: 16,
                              paddingLeft: 24,
                              minHeight: "56px",
                              textAlign: "-webkit-left",
                              fontWeight: 500,
                              fontSize: "17px",
                              color: "#111111",
                            } as any
                          }
                        ></Button>
                      </VerticalStack>
                    </KPanel>
                    <KPanel
                      key="956213"
                      id="956213"
                      scrolling="hidden"
                      scrollRadius={false}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          backgroundColor: "#FFFFFF",
                          paddingTop: 12,
                          paddingRight: 0,
                          paddingBottom: 24,
                          paddingLeft: 0,
                        } as any
                      }
                    >
                      <Button
                        key="116847"
                        id="116847"
                        label={ReactSystemFunctions.translate(
                          this.ml,
                          116847,
                          "label",
                          this.defaultML
                        )}
                        size="middle"
                        loading={false}
                        ghost={false}
                        block={false}
                        htmlType="button"
                        icon="logout"
                        iconPosition="left"
                        danger={false}
                        style={
                          {
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomRightRadius: 8,
                            borderBottomLeftRadius: 8,
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            backgroundColor: "#FFFFFF",
                            paddingTop: 16,
                            paddingRight: 24,
                            paddingBottom: 16,
                            paddingLeft: 24,
                            minHeight: "56px",
                            textAlign: "-webkit-left",
                            fontWeight: 500,
                            fontSize: "17px",
                            color: "#E53935",
                          } as any
                        }
                      ></Button>
                    </KPanel>
                  </VerticalStack>
                </KPanel>
              </div>
            </>
          </Form>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    spinnerCount: state.spinnerReducer.spinnerCount,
    photoTakeVisible: state.photoTakeReducer.visible,
    isImportMappedExcelModalVisible:
      state.importMappedExcelModalReducer.visible,
  };
};
const mapDispatchToProps = (dispatch) => ({
  showPhotoTake: () => dispatch(showPhotoTake()),
  hidePhotoTake: () => dispatch(hidePhotoTake()),
  showStripeDrawer: (data, callback, that, future) =>
    dispatch(showStripeDrawer(data, callback, that, future)),
  hideStripeDrawer: (data, callback, that) =>
    dispatch(hideStripeDrawer(data, callback, that)),
  showIyzicoDrawer: (data, callback, that) =>
    dispatch(showIyzicoDrawer(data, callback, that)),
  hideIyzicoDrawer: (data, callback, that) =>
    dispatch(hideIyzicoDrawer(data, callback, that)),
  showImportMappedExcelModal: (
    dsId,
    tableName,
    primaryKey,
    columnMapping,
    parameters
  ) =>
    dispatch(
      showImportMappedExcelModal(
        dsId,
        tableName,
        primaryKey,
        columnMapping,
        parameters
      )
    ),
  hideImportMappedExcelModal: () => dispatch(hideImportMappedExcelModal()),
});
const tmp = withGoogleLogin(
  withContext(
    withScreenInput(
      withForm(
        withHistory(
          connect(mapStateToProps, mapDispatchToProps)(SideMenu_Screen)
        )
      )
    )
  )
);
export { tmp as SideMenu_Screen };
//export default tmp;
//export { tmp as SideMenu_Screen };
